import compose from 'lodash/fp/compose';
import { shape, string } from 'prop-types';
import React from 'react';

import { withDocumentTitle } from '../../generic/DocumentTitle';
import Titled from '../../layout/Titled';
import { userShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import UserForm from '../UserForm';
import { fullName } from '../utils';

const ResolvedUserForm = compose(
  withResolved({
    query: api.getUser,
    deriveQueryArgs: props => ({ id: props.id }),
    as: 'model',
  }),
  withDocumentTitle(({ model }) => fullName(model)),
)(UserForm);

const ShowUser = ({ match, model }) => (
  <Titled title="User">
    <ResolvedUserForm id={match.params.id} model={model} />
  </Titled>
);

ShowUser.propTypes = {
  match: shape({ params: shape({ id: string.isRequired }).isRequired })
    .isRequired,
  model: userShape,
};

ShowUser.defaultProps = {
  model: undefined,
};

export default ShowUser;
